const fetchAs = require("./fetchAs");

module.exports = async function fetchListTaxonomyFilters(list_data, authContext) {
	const { field_entities_list_by_terms } = list_data;
	if (!field_entities_list_by_terms) return null;
	let _filteringByTerms = {};
	for (const a_term_rel of field_entities_list_by_terms) {
		let bundle = a_term_rel.type.split("--")[1];
		let _rel_entity = await fetchAs({
			endpoint: `taxonomy_term/${bundle}/${a_term_rel.id}`,
			authContext,
		});
		if (_rel_entity && _rel_entity.data) {
			_filteringByTerms[a_term_rel.id] = _rel_entity.data;
		}
	}
	return _filteringByTerms;
};
